export default __webpack_public_path__ + "static/media/address.a01cb8cc.png";